export const isCharadesQuestion = (question) =>
  question?.question_type === "secret_word";

const GENERIC_CHARADES_GUIDES = new Set([
  "وصّف الكلمة لفريقك!",
  "مثل الكلمة لفريقك!",
  "مثّل الكلمة لفريقك!",
  "مثل العنوان لفريقك دون أي كلام",
  "مثّل العنوان لفريقك دون أي كلام",
]);

export const getActorGuide = (value) => {
  const guide = typeof value === "string" ? value.trim() : "";
  if (!guide || GENERIC_CHARADES_GUIDES.has(guide)) return "";
  return guide;
};
